var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-icon',{attrs:{"caption":"パスワード変更","icon":"key","action":_vm.passwordChange}})}
var staticRenderFns = []

export { render, staticRenderFns }